import { providers } from "ethers";
import { useMemo } from "react";
import { useConnectorClient } from "wagmi";

export function clientToSigner(client) {
  if (!client) {
    console.log("Client is undefined");
    return undefined;
  }

  const { account, chain, transport } = client;
  if (!account || !chain || !transport) {
    console.log("Missing required client properties:", {
      account,
      chain,
      transport,
    });
    return undefined;
  }

  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };
  const provider = new providers.Web3Provider(transport, network);
  const signer = provider.getSigner(account.address);
  return signer;
}

/** Hook to convert a Viem Client to an ethers.js Signer. */
export function useEthersSigner({ chainId } = {}) {
  const { data: client } = useConnectorClient({ chainId });
  // console.log("Client state:", client);
  return useMemo(() => (client ? clientToSigner(client) : undefined), [client]);
}
